import { NotificationManager } from "react-notifications";
import { Actions as INTEGRATION_ACTIONS } from "../../../../store/actions/integrationActions";
import { Actions as COMPANYACTIONS } from "../../../../store/actions/companyActions";

import { uniqBy } from "lodash";
import { createRequest } from "../../../common/helpers/RequestHelpers";
import apiURL from "@/store/actions/apiURL";
import axios from "axios";

const timemotoRequest = createRequest({
	urlPath: "/integrations/timeMoto",
	// local: true,
});

const integrationRequest = createRequest({
	urlPath: "/integrations",
	// local: true,
});

const Types = {
    TIMEMOTO_CONNECT: "TIMEMOTO_CONNECT",
    TIMEMOTO_GET_PUNCH_CLOCKS: "TIMEMOTO_GET_PUNCH_CLOCKS",
    TIMEMOTO_CONNECTED: "TIMEMOTO_CONNECTED",
    TIMEMOTO_SAVING: "TIMEMOTO_SAVING",
    TIMEMOTO_LOADING: "TIMEMOTO_LOADING",
}

const timemotoPunchClocks = (data) => ({
    type: Types.TIMEMOTO_GET_PUNCH_CLOCKS,
    data
})

const setTimeMotoConnected = (response) => ({
    type: Types.TIMEMOTO_CONNECTED,
    response,
});

const setTimeMotoSaving = (status) => ({
    type: Types.TIMEMOTO_SAVING,
    status,
})

const setTimeMotoLoading = (status) => ({
    type: Types.TIMEMOTO_LOADING,
    status,
})

const connectTimeMoto = (serialNumber) => {
    return (dispatch, getState) => {

        timemotoRequest({
            path: "/connect",
            method: "POST",
            body: { serialNumber }
        }).then(({ data }) => {
            dispatch(INTEGRATION_ACTIONS.integrationGetList());
            NotificationManager.success("TimeMoto connected successfully!", 'Connect TimeMoto')
        }).catch((error) => {
            console.error(error)
            NotificationManager.error("Error connecting TimeMoto", "Connect TimeMoto")
        })
    }
}

const getTimeMotoPunchClocks = (serialNumber) => {
    return (dispatch, getState) => {
        dispatch(setTimeMotoLoading(true))

        timemotoRequest({
            path: "/punch-clocks",
            method: "GET",
        }).then(({ data }) => {
            dispatch(timemotoPunchClocks(data))
            dispatch(setTimeMotoLoading(false))
        }).catch((error) => {
            console.error(error.response)
            const errorToShow = error.response?.data?.error || "Getting TimeMoto Punch Clocks"
            NotificationManager.error(`Error: ${errorToShow}`, "TimeMoto")
            dispatch(setTimeMotoLoading(false))
        })
    }
}


const disconnectTimeMoto = () => {
    return (dispatch, getState) => {
        axios({
            method: 'POST',
            url: `${apiURL}/integrations/timeMoto/revoke`,
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })

    }
}

const updateTimeMotoPunchClocks = (data, finalClock) => {
    return (dispatch, getState) => {
        dispatch(setTimeMotoSaving(true));

        timemotoRequest({
            path: `/punch-clocks/${data.id}`,
            method: "POST",
            body: data
        }).then(({ data }) => {
            if (finalClock) {
                NotificationManager.success('TimeMoto Settings Saved Successfully', 'Saving TimeMoto Settings');
                dispatch(setTimeMotoSaving(false));
            }
        }).catch((error) => {
            console.error(error);
            NotificationManager.error('Error Saving TimeMoto Settings', 'Saving TimeMoto Settings');
            if (finalClock) dispatch(setTimeMotoSaving(false));
        })
    }
}

const Actions = {
    connectTimeMoto,
    disconnectTimeMoto,
    getTimeMotoPunchClocks,
    updateTimeMotoPunchClocks,
};

export { Actions, Types };
